import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import {
  NavbarSidebarWrapper,
  NavbarSidebarWrapperProps,
} from "src/layouts/navbar-sidebar-wrapper";
import { OnboardingLayout } from "src/layouts/onboarding-layout";
// import { ForceRoute } from "src/components";
import { routes, customersRoutes } from "./routes";
import PrivateRoute from "./private.route";
import { lazy } from "react";
import { ErrorBoundary } from "src/components/shared/ErrorBoundary";
import CustomersLayout from "src/pages/customers/CustomersLayout";

const NotFound = lazy(() => import("src/pages/404/index"));
const EmailSenderVerifyPage = lazy(
  () => import("src/pages/email/senders/verify"),
);
const UnsubscribePage = lazy(() => import("src/pages/unsubscribe"));

// layout customization for each route
const { noFooterRoutes, noWrapperRoutes } = routes.private.reduce(
  (
    { noFooterRoutes, noWrapperRoutes },
    { noFooterRoute, noWrapperRoute, path },
  ) => ({
    noFooterRoutes: noFooterRoute ? [...noFooterRoutes, path] : noFooterRoutes,
    noWrapperRoutes: noWrapperRoute
      ? [...noWrapperRoutes, path]
      : noWrapperRoutes,
  }),
  {
    noFooterRoutes: [],
    noWrapperRoutes: [],
  } as Required<NavbarSidebarWrapperProps>,
);

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public route — sender email verification (no auth required) */}
        <Route
          path="email/senders/:id/verify/:token"
          element={
            <ErrorBoundary>
              <EmailSenderVerifyPage />
            </ErrorBoundary>
          }
        />

        {/* Public route — email unsubscribe (no auth required) */}
        <Route
          path="unsubscribe"
          element={
            <ErrorBoundary>
              <UnsubscribePage />
            </ErrorBoundary>
          }
        />

        {/* Onboarding routes - protected but without main layout */}
        <Route
          element={
            <PrivateRoute>
              <OnboardingLayout />
            </PrivateRoute>
          }
        >
          {routes.onboarding.map(({ path, Component }) => (
            <Route key={path} path={path} element={<ErrorBoundary><Component /></ErrorBoundary>} />
          ))}
        </Route>

        {/* Main private routes with layout */}
        <Route
          element={
            <PrivateRoute>
              <NavbarSidebarWrapper
                noFooterRoutes={noFooterRoutes}
                noWrapperRoutes={noWrapperRoutes}
              />
            </PrivateRoute>
          }
        >
          {routes.private.map(({ path, Component }) => (
            <Route key={path} path={path} element={<ErrorBoundary><Component /></ErrorBoundary>} />
          ))}

          {/* Customers (CDP) routes — wrapped in CustomersLayout for AI Copilot panel */}
          <Route path="customers" element={<CustomersLayout />}>
            {customersRoutes.map(({ path, Component }) => (
              <Route key={path} path={path} element={<ErrorBoundary><Component /></ErrorBoundary>} />
            ))}
          </Route>

          {/* Catch unmatched private routes */}
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Catch all unmatched routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
